<script lang="ts" setup>
import { useFleetStore } from '@/domains/fleet/fleetStore'
import { useUserStore } from '@/domains/user/userStore'
import { useFeatureStore } from '@/stores/featureStore'
import { computed } from 'vue'

const userStore = useUserStore()
const fleetStore = useFleetStore()
const featureStore = useFeatureStore()

const user = computed(() => userStore.getCurrentUser)
const isAdmin = computed(() => featureStore.can('invite-users'))
const fleet_name = computed(() => fleetStore.fleetName)
const logo_url = computed(() => fleetStore.logoSrc ?? undefined)
</script>
<template>
  <v-card class="pa-5 d-flex align-center" flat>
    <v-img :src="logo_url" max-width="110" class="mb-4" />
    <v-card flat class="flex-1" color="transparent">
      <v-card-title>{{ fleet_name }}</v-card-title>
      <v-card-text>
        <p>{{ isAdmin ? 'Admin' : 'Member' }}</p>
        <p>{{ user?.fullName ?? 'Guest user'}}</p>
      </v-card-text>
    </v-card>
  </v-card>
</template>
